<template>
  <div class="rectification-board">
    <div v-for="item in rectificationInfo" :key="item.unitCode" >
      <card class="board-card" @clickBoard="showDetails" :rectificData="item"/>
    </div>
    <detail
    v-if="rectificationVisible"
    :visible="rectificationVisible"
    :unitCode="unitCode"
    :title="title"
    @close="closeRectificationDialog"
    />
  </div>
</template>
<script>
import dayjs from 'dayjs'
import card from './cards.vue'
import detail from './detail.vue'
import request from '@/utils/request'

export default {
  components: {
    card,
    detail,
  },
  data() {
    return {
      rectificationVisible: false,
      title: '',
      rectificationInfo: [],
      unitCode: ''
    }
  },
  mounted() {
    this.getRectificationInfo()
  },
  methods: {
    closeRectificationDialog(val) {
      this.rectificationVisible = val
    },
    showDetails(title, unitCode) {
      this.title = title
      this.unitCode = unitCode
      this.rectificationVisible = true
    },
    async getRectificationInfo() {
      try {
        // const day = dayjs()
        // const formattedToday = day.format('YYYY-MM-DD HH:mm:ss')
        // const threeMonthsAgo = day.subtract(3, 'month')
        // const formattedThreeMonthsAgo = threeMonthsAgo.format('YYYY-MM-DD HH:mm:ss')

        const res = await request({
          url: '/customer/bizUnitRectifyFeedbackData',
          method: 'get',
          // params: {
          //   beginTime: formattedThreeMonthsAgo,
          //   endTime: formattedToday,
          // },
          headers: {
            'Content-Type': 'x-www-form-urlencoded',
          },
        })
        const { data } = res
        this.rectificationInfo = data
      } catch (error) {
        console.log(error)
      }
    },
  }
}

</script>

<style lang="scss" scoped>
.rectification-board {
  display: grid;
  margin-left: -16px;
  margin-top: -16px;
  grid-template-columns: repeat(5,1fr);
  .board-card {
    margin-left: 16px;
    margin-top: 16px;
  }
}
</style>
